import { LDProvider } from 'launchdarkly-react-client-sdk';
import React, { useMemo, type JSX } from 'react';
import accessToken from '|/helpers/access-token';
import Cookies from 'js-cookie';
import telemetryService from '|/app/services/telemetry/telemetry-service';
import { defaultFlags } from './useFeatureFlags';

export const LaunchDarklyProvider: React.FC<React.PropsWithChildren<{}>> = ({
  children
}): JSX.Element => {
  const context = useMemo(() => {
    try {
      const token = accessToken();
      if (token?.user?.user_id) {
        return {
          kind: 'user',
          key: 'purchase-ui',
          userId: token.user.user_id,
          userBcid: Cookies.get('BrowserCookieId')
        };
      }
    } catch (error) {
      telemetryService.trackError({
        name: 'launch-darkly:get-user-id:error',
        error,
        context: {
          message: 'Error getting user ID for LaunchDarkly'
        }
      });
    }

    const anonymousId = Cookies.get('BrowserCookieId') || 'anonymous-user';
    return {
      kind: 'user',
      key: 'purchase-ui',
      userBcid: anonymousId,
      anonymous: true
    };
  }, [accessToken]);

  return (
    <LDProvider
      clientSideID={process.env.LAUNCH_DARKLY_CLIENTID ?? ''}
      context={context}
      flags={defaultFlags}
    >
      {children}
    </LDProvider>
  );
};
